import { IDrawItem, IDrawBudgetItem } from '@apply/api/src/api/DrawApi';

export const calculateBalance = (drawNumber: number, drawItems?: IDrawItem[]): number | undefined => {
    if (!drawItems) return undefined;

    const drawItem = drawItems.find((item) => item.drawNumber == drawNumber);
    if (drawItem?.inspection === undefined) return undefined;

    const totalFunded = drawItems.reduce((sum, item, i) => {
        if (i > drawNumber) return sum;
        if (!item?.funded) return sum;

        return item.funded + sum;
    }, 0);

    if (totalFunded === 0) return undefined;

    const outOfBalance = totalFunded - (drawItem?.inspection ?? 0);

    if (outOfBalance > 0) return outOfBalance;

    return undefined;
};

export interface DrawBudgetCategory {
    id: number;
    description: string;
}

export const getDrawBudgetCategories = (drawBudgetItems: IDrawBudgetItem[]): DrawBudgetCategory[] => {
    return (
        drawBudgetItems
            .filter((item) => item.id > 0)
            .map((item) => {
                return { id: item.id, description: item.description } as DrawBudgetCategory;
            }) ?? []
    );
};
